import React from "react";
import { isEmpty, isEqual } from "lodash";

import { CloseDialog } from "components/Dialog";
import Button from "components/Button";
import Dialog from "components/Dialog";
import Input from "components/Input";

import classes from "../style.module.scss";

const RenameDialog = ({
    toRename,
    close,
    oldFolderName,
    newFolderName,
    setNewFolderName,
    onClick,
    folderLoading,
}) => (
    <Dialog open={!!toRename}>
        <CloseDialog closeActions={() => close()} />
        <div className={classes.dialog}>
            <h3>Rename Folder</h3>
            <Input
                label={"New Folder Name"}
                placeholder="Type new folder name..."
                disabled={folderLoading}
                input={{
                    value: newFolderName,
                    onChange: (value) => setNewFolderName(value),
                }}
            />
            <div className={classes.footer}>
                <Button type="hollow" onClick={() => close()}>
                    Cancel
                </Button>
                <Button onClick={onClick} type="" disabled={folderLoading || isEmpty(newFolderName) || isEqual(newFolderName, oldFolderName)}>
                    {folderLoading ? "Renaming..." : "Rename"}
                </Button>
            </div>
        </div>
    </Dialog>
);

export default RenameDialog;
